module.exports = __webpack_public_path__ + "static/media/Portrait-10061.0e4ca8ba.jpg";